import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { initTCPlus } from '../utils/initTCPlus';
import { FullPageLoader } from '../../common/components/FullPageLoader';
import { useQuery } from '../../common/hooks';

const TcPlusSplashPage = (): JSX.Element => {
  const history = useHistory();
  const { linkId: link } = useParams<{ linkId: string }>();
  const query = useQuery();
  const assessmentCompletionURL = query.get('TPURLC');
  const assessmentNonCompletionURL = query.get('TPURLNC');
  const payload = { link, resetIndicator: false, assessmentCompletionURL, assessmentNonCompletionURL };
  useEffect(() => {
    sessionStorage.clear();
    localStorage.clear();
    const initTcPlusExperience = async (): Promise<void> => {
      await initTCPlus(payload, history);
    };
    initTcPlusExperience();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <FullPageLoader isLoading />;
};

export default TcPlusSplashPage;
